import { render, staticRenderFns } from "./NoSidebar.vue?vue&type=template&id=caf72b22&scoped=true"
import script from "./NoSidebar.vue?vue&type=script&lang=js"
export * from "./NoSidebar.vue?vue&type=script&lang=js"
import style0 from "./NoSidebar.vue?vue&type=style&index=0&id=caf72b22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf72b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caf72b22')) {
      api.createRecord('caf72b22', component.options)
    } else {
      api.reload('caf72b22', component.options)
    }
    module.hot.accept("./NoSidebar.vue?vue&type=template&id=caf72b22&scoped=true", function () {
      api.rerender('caf72b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/NoSidebar.vue"
export default component.exports